import axios from 'axios';
import { ACR, BASE_URL, REGIONS, PLANNER_EIN, PLANNER_REGION } from "../../constant/urls";

export const setFilter = async (setSnackopen, setSnackmsg, setLoading, params, filters, excludeSolutions ,setSnackSuccess,setSuccessAlert) => {
try{
    const payload = {
        cable_weight: {operator: filters.cable_weight.operator, value:filters.cable_weight.value},
        divertPerTone: {operator: filters.divertPerTone.operator, value:filters.divertPerTone.value},
        kgPerMeter: {operator: filters.kgPerMeter.operator, value:filters.kgPerMeter.value},
        netCost: {operator: filters.netCost.operator, value:filters.netCost.value},
        tonePerCab: {operator: filters.tonePerCab.operator, value:filters.tonePerCab.value},
        solution: excludeSolutions.toString(),
        logged_user: JSON.parse(localStorage.getItem("USER_EIN")),
    }
    
    const url = `${BASE_URL}/${ACR}/filter_conditions`
    const response = await axios.post(url, payload);
     if(response.data.status_code === 200 && response.data.status.toLowerCase() === "success")
    {   
        setSuccessAlert(true);
        setSnackSuccess(response.data.message);
        setLoading(false);
    }
     else if(response.data.status_code === 200 && response.data.status.toLowerCase() === "fail") 
    {
        setSnackmsg(response.data.message);
        setSnackopen(true); 
        setLoading(false);
    }

}
catch (error) {
    console.error(error);
    setSnackopen(true);
    setSnackmsg('Something went wrong! Please try again.');
    setLoading(false);
}
};

export const fetchRegionsAPI = async ( setSnackmsg, setLoading, setSnackopen, params ) => {  
    try {
        const mergedParams = { ...params, is_admin: true };
        const response = await axios.get(`${BASE_URL}/${ACR}${REGIONS}`, { params: mergedParams });
        setLoading(false);
        const data = response?.data?.results?.[0] ?? [];
        return data.map(item => item.ouc);
        //return response?.data?.results.map(item => item.ouc);
      
    } catch (error) {
        console.error(error); 
        setSnackopen(true);
        setSnackmsg('Something went wrong! Please try again.');
        setLoading(false);
        return [];
    }
};

export const fetchPlannerEinAPI = async ( setSnackmsg, setLoading, setSnackopen, params ) => {
    try {
        setLoading(true);
        const logged_user = JSON.parse(localStorage.getItem("USER_EIN")) || "";
        const combinedParams = { logged_user, ...params };
        const response = await axios.get(`${BASE_URL}/${ACR}${PLANNER_EIN}`, {
            params: combinedParams
        });
        setLoading(false);
        return response?.data?.results || [];
    } catch (error) {
        console.error(error); 
        setSnackopen(true);
        setSnackmsg('Something went wrong! Please try again.');
        setLoading(false);
        return [];
    }
};

export const setSubmit = async (setSnackopen, setSnackmsg, setLoading, plannerEIN, region,setSnackSuccess,setSuccessAlert ) => {
    try{
        const payload = {
            admin_ein: JSON.parse(localStorage.getItem("USER_EIN")),
            planner_ein: plannerEIN,
            region: region
        }
        const response = await axios.post(`${BASE_URL}/${ACR}${PLANNER_REGION}`, payload);
        if(response.data.Status_code === 200 && response.data.status.toLowerCase() === "success")
        {
            setSnackSuccess(response.data.message);
            setSuccessAlert(true);
            setLoading(false);
            localStorage.setItem("selectedOUC", JSON.stringify(region));
        }
        else if(response.data.Status_code === 200 && response.data.status.toLowerCase() === "failure") 
        {
            setSnackmsg(response.data.message);
            setSnackopen(true);
            setLoading(false);
        }
    
    }
    catch (error) {
        console.error(error);
        setSnackopen(true);
        setSnackmsg('Something went wrong! Please try again.');
        setLoading(false);
    }
    };  

export const fetchFiltersAPI = async (setSnackmsg, setSnackopen, params) => {
      try {
        
        const response = await axios.get(`${BASE_URL}/${ACR}/view_filter`, { params: params});
        return response?.data?.results|| {};
        
      } catch (error) {
        console.error(error);
        setSnackopen(true);
        setSnackmsg('Something went wrong! Please try again.');
        return {};
      }
    };